import * as bowser from 'bowser';
const browser = bowser.getParser(window.navigator.userAgent);
const osInfo = browser.getOS();
export function getPathSeparator() {
    if (osInfo && osInfo.name === 'Windows') {
        return '\\';
    }
    return '/';
}
//# sourceMappingURL=helpers.js.map